// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.djs-overlay-linting .bjs-linting-annotation{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/App/Pages/Diagram/override.scss"],"names":[],"mappings":"AAEE,6CACE,cAAA","sourcesContent":[".djs-overlay-linting {\n\n  .bjs-linting-annotation {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
